import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import perfilImg from '../../assets/images/perfil.png'; // Reutilizamos la imagen de perfil de Gustavo

import {
  FaWhatsapp, FaCalendarAlt, FaStar, FaMountain, FaWater, FaLeaf, FaHandsHelping,
  FaCampground, FaHotdog, FaSpa, FaSnowflake, FaHiking, FaBed, FaUtensils, FaCheckCircle,
} from "react-icons/fa";
import { GiMeditation, GiBrain, GiHeartOrgan } from "react-icons/gi"; // GiYoga ha sido removido

// --- Componentes reutilizables (puedes moverlos a un archivo shared/ si los usas en varios lugares) ---
const InViewSection = ({ title, children, index, id, titleColor = "text-teal-300" }) => (
  <section
    id={id}
    className="w-full max-w-lg mx-auto mb-12 p-6 rounded-xl border border-gray-700 bg-black/40 shadow-xl shadow-gray-900/50 fade-in-up"
    style={{ animationDelay: `${index * 150 + 700}ms` }}
  >
    <h3 className={`text-2xl font-bold mb-5 text-center ${titleColor} border-b border-gray-700 pb-3`}>{title}</h3>
    {children}
  </section>
);

const CTAButtonsRetreat = ({ delay }) => (
  <div
    className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 w-full max-w-md fade-in-up"
    style={{ animationDelay: `${delay}ms` }}
  >
    <a
      href={`https://wa.me/5491150254270?text=${encodeURIComponent("Hola Gustavo, ¡quiero reservar mi lugar para el Retiro de Inmersión en Hielo!")}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center px-7 py-3 rounded-xl border border-green-600 bg-green-700/60 text-white font-bold text-lg shadow-lg shadow-green-700/40 hover:bg-green-600 hover:scale-105 transition-all duration-300 ease-in-out w-full sm:w-auto"
    >
      <FaWhatsapp className="mr-3 text-2xl" /> Quiero reservar ahora
    </a>

    <div className="flex flex-col items-center w-full sm:w-auto">
      <a
        href="https://calendly.com/gustavonahuelaguiar/30min" // Asumo que se mantiene el Calendly para más info
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center px-7 py-3 rounded-xl border border-teal-600 bg-teal-700/60 text-white font-bold text-lg shadow-lg shadow-teal-700/40 hover:bg-teal-600 hover:scale-105 transition-all duration-300 ease-in-out w-full sm:w-auto"
      >
        <FaCalendarAlt className="mr-3 text-2xl" /> Agendar llamada informativa
      </a>
      <span className="text-xs text-gray-400 mt-1">Resolvemos todas tus dudas – sin compromiso</span>
    </div>
  </div>
);
// --------------------------------------------------------------------------------------------------


const IceImmersionRetreatPage = () => {
  const { user } = useAuth();

  const retreatActivities = [
    { text: "Sesiones diarias de Yoga y movimiento consciente.", icon: <FaCheckCircle /> },
    { text: "Meditaciones Guiadas para conectar con tu interior.", icon: <GiMeditation /> },
    { text: "Prácticas de Respiración Consciente (Pranayamas) para regular tu energía.", icon: <GiBrain /> },
    { text: "Inmersiones en Hielo: Desafía tus límites y activa tu fortaleza interna.", icon: <FaSnowflake /> },
    { text: "Trekking Consciente por los paisajes de Umepay y Villa Yacanto.", icon: <FaHiking /> },
    { text: "Momentos de conexión grupal y espacio para la introspección personal.", icon: <FaHandsHelping /> },
  ];

  const benefits = [
    { text: "Potenciar tu resiliencia física y mental.", icon: <GiHeartOrgan /> },
    { text: "Liberar el estrés y la ansiedad acumulada.", icon: <FaSpa /> },
    { text: "Mejorar la calidad de tu sueño y tu energía diaria.", icon: <FaLeaf /> },
    { text: "Fortalecer tu sistema inmunológico y circulatorio.", icon: <FaCheckCircle /> },
    { text: "Conectar profundamente con la naturaleza y contigo mismo/a.", icon: <FaMountain /> },
    { text: "Descubrir una nueva dimensión de tu poder interior.", icon: <FaStar /> },
  ];

  const faqs = [
    { q: "¿Necesito experiencia previa en yoga o inmersión en hielo?", a: "No, el retiro está diseñado para todos los niveles, desde principiantes hasta avanzados. Te guiaremos paso a paso." },
    { q: "¿Cómo llego a Umepay?", a: "El transporte no está incluido. Umepay se encuentra en Villa Yacanto, Córdoba. Te facilitaremos información detallada sobre cómo llegar desde las principales ciudades y opciones de traslado local." },
    { q: "¿Qué tipo de alojamiento tendré?", a: "Te hospedarás en un alojamiento confortable en la naturaleza de Umepay, con habitaciones compartidas y espacios comunes diseñados para el relax y la conexión." },
    { q: "¿Se ofrecen opciones de comida para dietas especiales?", a: "Sí, por favor infórmanos con antelación sobre cualquier requerimiento dietético (vegetariano, vegano, celíaco, etc.) para que podamos asegurarnos de satisfacer tus necesidades." },
    { q: "¿Qué tan fría está el agua de la inmersión en hielo?", a: "El objetivo es una inmersión controlada en agua a bajas temperaturas (cerca de 0-5°C). Estarás siempre bajo supervisión y con guías que te prepararán para la experiencia." },
  ];


  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col relative overflow-hidden">
      {/* Fondo degradado de verde oscuro profundo */}
      <div className="fixed inset-0 bg-gradient-to-br from-[#0F3A2E] via-[#08231C] to-[#0F3A2E] opacity-95 z-0 animate-gradient-shift"></div>

      <style>
        {`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-shift {
          background-size: 200% 200%;
          animation: gradient-shift 15s ease infinite;
        }
        .fade-in-up {
          animation-fill-mode: both;
          animation-duration: 0.8s;
          animation-name: fade-in-up-keyframes;
          opacity: 0;
          transform: translateY(20px);
        }
        @keyframes fade-in-up-keyframes {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        `}
      </style>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        {/* HERO SECTION */}
        <h1
          className="text-4xl sm:text-6xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-teal-300 via-sky-300 to-cyan-400 text-center leading-tight fade-in-up"
          style={{ animationDelay: '100ms' }}
        >
          Retiro de Inmersión en Hielo
        </h1>

        <p
          className="text-2xl sm:text-4xl text-gray-100 text-center max-w-2xl mb-3 font-light fade-in-up" // Margen ajustado
          style={{ animationDelay: '250ms' }}
        >
          Despertá tu Fortaleza en el Corazón de Córdoba.
        </p>

        {/* <-- AÑADIDO: Fechas del retiro --> */}
        <p
          className="text-xl sm:text-2xl text-teal-200 font-semibold text-center max-w-xl mb-5 fade-in-up" // Destacado para las fechas
          style={{ animationDelay: '350ms' }}
        >
          Fechas: 14, 15 y 16 de Noviembre
        </p>
        {/* <-- FIN AÑADIDO --> */}

        <p
          className="text-lg sm:text-xl text-gray-400 text-center max-w-xl mb-12 fade-in-up"
          style={{ animationDelay: '400ms' }}
        >
          Un fin de semana transformador en la naturaleza de Umepay para conectar, sanar y expandir tus límites.
        </p>

        {/* Suggested image placeholder */}
        {/* <div className="mb-12 w-full max-w-md rounded-xl overflow-hidden shadow-2xl fade-in-up" style={{ animationDelay: '550ms' }}>
          <img src="/path/to/umepay-landscape.jpg" alt="Paisaje de Umepay" className="w-full h-64 object-cover" />
        </div> */}

        {/* CTA inicial */}
        <div className="w-full max-w-lg mx-auto mb-12 flex justify-center">
          <CTAButtonsRetreat delay={700} />
        </div>

        {/* QUÉ INCLUYE EL RETIRO */}
        <InViewSection title="Un Fin de Semana de Transformación" index={0} id="que-incluye">
          <p className="text-gray-300 mb-4 text-center">
            Diseñado para recargar tu espíritu y desafiar tu mente y cuerpo.
          </p>
          <ul className="list-none pl-0 text-gray-300 space-y-3">
            {retreatActivities.map((item, i) => (
              <li key={i} className="flex items-center">
                <span className="text-teal-400 mr-3 text-xl flex-shrink-0">{item.icon}</span>
                <span>{item.text}</span>
              </li>
            ))}
            <li className="flex items-center font-semibold text-teal-300">
              <FaBed className="mr-3 text-xl flex-shrink-0" />
              <span>Alojamiento por 3 días y 2 noches (Viernes a Domingo).</span>
            </li>
            <li className="flex items-center font-semibold text-teal-300">
              <FaUtensils className="mr-3 text-xl flex-shrink-0" />
              <span>Todas las comidas incluidas (pensión completa).</span>
            </li>
          </ul>
        </InViewSection>

        {/* UBICACIÓN Y AMBIENTE */}
        <InViewSection title="Umepay: Tu Santuario Natural" index={1} id="ubicacion">
          <p className="text-gray-300 mb-4 text-center">
            Nos encontramos en Umepay, un pintoresco pueblo en Villa Yacanto, Córdoba.
            Un lugar mágico, rodeado de montañas y aire puro, ideal para la introspección y la conexión con la Madre Tierra.
          </p>
          {/* Suggested image placeholder */}
          {/* <div className="mt-6 w-full rounded-xl overflow-hidden shadow-xl">
            <img src="/path/to/umepay-river.jpg" alt="Río en Umepay" className="w-full h-48 object-cover" />
          </div> */}
          <p className="text-sm text-gray-500 mt-4 text-center">
            (El transporte hasta Umepay no está incluido, pero te brindaremos toda la información necesaria para llegar.)
          </p>
        </InViewSection>

        {/* LOGÍSTICA IMPORTANTE */}
        <InViewSection title="Preparate para la Aventura" index={2} id="logistica">
          <ul className="list-disc pl-5 text-gray-300 space-y-2">
            {/* <-- CAMBIO AQUÍ: Fechas añadidas al punto de duración --> */}
            <li><span className="font-semibold text-teal-300">Duración:</span> 3 días y 2 noches (Viernes 14 al Domingo 16 de Noviembre).</li>
            <li><span className="font-semibold text-teal-300">Qué traer:</span>
              <ul className="list-disc pl-5 text-gray-400 mt-1 space-y-1">
                <li>Tu propio mat de yoga.</li>
                <li>Ropa cómoda y abrigada para las noches frescas de montaña.</li>
                <li>Malla o traje de baño para las inmersiones en hielo y el río.</li>
                <li>Calzado cómodo para trekking.</li>
                <li>Botella de agua reutilizable.</li>
              </ul>
            </li>
          </ul>
          {/* Suggested image placeholder for 'what to bring' items */}
          {/* <div className="mt-6 w-full rounded-xl overflow-hidden shadow-xl">
            <img src="/path/to/yoga-mat-water.jpg" alt="Preparativos para el retiro" className="w-full h-40 object-cover" />
          </div> */}
        </InViewSection>

        {/* LO QUE LOGRARÁS */}
        <InViewSection title="Beneficios que te esperan" index={3} id="beneficios">
          <ul className="list-none pl-0 text-gray-300 space-y-3">
            {benefits.map((b, i) => (
              <li key={i} className="flex items-center">
                <span className="text-green-400 mr-3 text-xl flex-shrink-0">{b.icon}</span>
                <span>{b.text}</span>
              </li>
            ))}
          </ul>
        </InViewSection>

        {/* TU INVERSIÓN */}
        <InViewSection title="Inversión en tu Bienestar Profundo" index={4} id="precio">
          <div className="text-center">
            <p className="text-4xl sm:text-5xl font-extrabold text-teal-300 mb-2">
              $377 <span className="text-xl sm:text-2xl text-gray-400">USD</span>
            </p>
            <p className="text-2xl sm:text-3xl font-bold text-teal-300 mb-6">
              Reserva tu lugar con $177 <span className="text-lg text-gray-400">USD</span>
            </p>
            <p className="text-lg text-gray-300 mb-6">
              El pago restante se coordina directamente con Gustavo.
            </p>
            <CTAButtonsRetreat delay={0} />
          </div>
        </InViewSection>

        {/* Conoce a tu guía (reutilizado de MainCoursePage) */}
        <InViewSection title="Conocé a tu guía:" index={5} id="sobre-mi">
          <img
            src={user?.profileImage || perfilImg}
            alt="Perfil de Gustavo Aguiar"
            className="w-32 h-32 sm:w-40 sm:h-40 rounded-full mb-5 object-cover border-4 border-teal-400 shadow-xl mx-auto transform hover:scale-105 transition-transform duration-300"
          />
          <h2 className="text-xl sm:text-3xl font-bold mb-2 text-center text-teal-300">Gustavo Aguiar</h2>
          <p className="text-sm sm:text-base text-gray-300 text-center max-w-sm mx-auto leading-relaxed">
            Coach Holístico. Con años de experiencia en técnicas de respiración, meditación y bienestar integral, Gustavo te acompañará en cada paso de esta inmersión para que descubras tu ilimitado potencial.
          </p>
        </InViewSection>

        {/* PREGUNTAS FRECUENTES */}
        <InViewSection title="Preguntas Frecuentes" index={6} id="faqs">
          <div className="space-y-6">
            {faqs.map((f, i) => (
              <div key={i} className="bg-gray-900/30 p-4 rounded-lg shadow-inner">
                <p className="font-bold text-teal-300 mb-1 flex items-center">
                  <span className="mr-2 text-xl">?</span> {f.q}
                </p>
                <p className="text-gray-200">{f.a}</p>
              </div>
            ))}
          </div>
        </InViewSection>

        {/* CTA FINAL */}
        <div className="w-full max-w-lg mx-auto mb-16 flex justify-center">
          <CTAButtonsRetreat delay={1600} />
        </div>
      </main>

      {/* FOOTER */}
      <footer
        className="relative z-10 text-center py-8 text-xs text-gray-500 bg-black/50 border-t border-gray-800 fade-in-up"
        style={{ animationDelay: '1750ms' }}
      >
        <p>© {new Date().getFullYear()} Gustavo Aguiar | Inmersión y Conexión en la Naturaleza.</p>
        <p className="mt-1">Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default IceImmersionRetreatPage;